import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getTagsGQL = () => {
  const query = `
    query{
       getTags(type: CLIENT){
            edges {
                 node {
                    id
                    value
                    type
                 }
            }
       }
    }
  `
  return callAuthorizedGraphQLEndpoint(query)
}

export { getTagsGQL }



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientAdd/gql.js